import { TPopClientFeaturesList } from '@ConfigLoader/Configs';
import { TUILayerGameStoreSchema } from '@GameStore/GameStoreSchema';
import { TSceenBreakpoints } from '@Managers/Device/UseWindowDimensions.types';
import { EGameStates } from '@Managers/StateManager/GameStates';
import { EMessagesTypes } from '@UILayer/Modules/PopupMessage/PopupMessage.types';

export type TErrorMessages = {
    code?: number;
    subCode?: number;
    message?: string;
    type?: string;
    description?: string;
    action?: Function;
};

export type TDeviceInfo = {
    docHeight: number;
    docWidth: number;
    appHeight: number;
    appWidth: number;
    appTopOffset: number;
    appRightOffset: number;
    appLeftOffset: number;
    appBottomOffset: number;
    windowOrientation: string;
    windowOrientationPortrait: boolean;
    windowOrientationHorizontal: boolean;
    isMobile: boolean;
    screenSize: TSceenBreakpoints;
    isiOS: boolean;
    fullScreen: boolean;
    aspectRatio: number;
    uiMaxCoverage: number;
    isTabletHorizontal: boolean;
    isTabletPortrait: boolean;
};

export type TFreeSpinState = {
    active?: boolean;
    balance?: number;
    bet?: number;
};

export type TMaitananceModeData = {
    // GAMEPRO
    active?: boolean;
    event?: string;
    startAt?: string;
    plannedEndAt?: string;
    // RGS
    time?: number;
};

export type TPopupMessage = {
    type: EMessagesTypes | undefined;
};

export type TFixesStateData = {
    active: boolean;
    currentIndex: undefined | number;
    fixArray: string[];
    fixArrayPredefined: string[];
    fixCombinations: string[];
    fixReelPosition: { [key: number]: number };
    saveOnRefresh: boolean;
    extendedSelector: boolean;
};

export type TGamePerformance = {
    targetFps: number;
    actualFps: number;
    fpsVsTarget: string;
    deltaVsTarget: string;
    frame: number;
    delta: number;
    rawDelta: number;
};

export type TCasinoMenu = {
    lobby?: TCasinoMenuItem;
    history?: TCasinoMenuItem;
    cashier?: TCasinoMenuItem;
};

export type TCasinoMenuItem = {
    active: boolean;
    url: string;
    title: string;
};

export type TPopClient = {
    enabled: boolean;
    initialized: boolean;
    supportedFeatures: TPopClientFeaturesList;
};

export type TUiState = { visible: boolean; uiFreeze: boolean };

export const CASINO_MENU_ITEM_DEFAULT = {
    active: false,
    url: '',
    title: ''
};

export type TGlobalStyles = {
    orientation: React.CSSProperties;
    device: React.CSSProperties;
    wcaMode: React.CSSProperties;
    handMode: React.CSSProperties;
    wideDevice: React.CSSProperties;
    screenSize: React.CSSProperties;
    balanceFontSize: number;
    settingsBaseFontSize: number;
    isTablet: React.CSSProperties;
};

export enum TPopupPanel {
    bet = 'popup_bet',
    autoPlay = 'popup_autoplay'
}

export type TInGameHistoryPage = {
    active: boolean;
    url: string;
};
export interface AppState {
    init: boolean;
    maintananceMode: {
        active: boolean;
        time: undefined | { h: number; m: number; s: number };
        startAt: string;
        plannedEndAt: string;
    };
    gameStore: TUILayerGameStoreSchema;
    wcaMode: boolean;
    loggedOut: boolean;
    readyState: boolean;
    canvasReady: boolean;
    popupPanel: false | TPopupPanel;
    menuPages: boolean;
    debugTools: boolean;
    device: TDeviceInfo;
    leftHandMode: boolean;
    inGameHistoryMode: boolean;
    popupMessage: undefined | TPopupMessage;
    casinoMenu: TCasinoMenu;
    fixesState: TFixesStateData;
    currentGameState: EGameStates;
    gamePerformance: TGamePerformance;
    uiState: TUiState;
    globalStyles: TGlobalStyles;
    popClient: TPopClient;
    inGameHistoryPage: TInGameHistoryPage;
}
